import Navigation from "./Navigation";

  const Sidebar = ({ data }) => {
    return (
      <section className="Sidebar" >

        <a href="/" className="Sidebar__Logo"></a>
       <Navigation />
        <div className="Sidebar__Pattern"></div>
      </section>
    );
  };

  export default Sidebar;